import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AtributeCopiiService } from '../atribute-copii.service';
import { finalize, map, Observable } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { AtributeCopiiAddPayload, AtributeCopiiEditPayload } from '../atribute-copii.interface';
import { Generic } from 'src/app/interfaces/generic.interface';
import { notDefaultValidator } from 'src/app/validators/not-default';
import { GrupAtributeService } from '../../grup-atribute/grup-atribute.service';

@Component({
    selector: 'app-edit-atribute-copii',
    templateUrl: './edit-atribute-copii.component.html',
    styleUrls: ['./edit-atribute-copii.component.scss']
})
export class EditAtributeCopiiComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    isLoading = false;

    grupuriAtribute$!: Observable<Generic[]>;

    filterParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        slug: new FormControl(this.data.slug, [Validators.required]),
        description: new FormControl(this.data.description, [Validators.required]),
        group_id: new FormControl(this.data.group_id, [Validators.required, notDefaultValidator('-1')]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditAtributeCopiiComponent>,
        private requestService: AtributeCopiiService,
        private grupAtributeService: GrupAtributeService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() {
        this.loadGrupuriAtributeActive();
    }

    loadGrupuriAtributeActive() {
        this.isLoading = true;
        this.grupuriAtribute$ = this.grupAtributeService
            .getListActive()
            .pipe(
                map((results: any) => [this.filterParameter, ...results]),
                finalize(() => (this.isLoading = false))
            );
    }

    submitForm() {
        this.isLoading = true;

        const { name, slug, description, group_id } = this.form
            .value as AtributeCopiiAddPayload;
        const payload: AtributeCopiiEditPayload = {
            id: this.data.id,
            name,
            slug,
            description,
            group_id
        };

        this.requestService
            .updateEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
